export default __webpack_public_path__ + "static/media/blur-close-up-computer-keyboard-459737-min.efe87eb4.jpg";